import moment from 'moment-timezone';

const SERVER_TIMEZONE: string = process.env.REACT_APP_SERVER_TIMEZONE || 'UTC';

/**
 * Format an ISO date string received from backend to the raw DB date.
 * When the DB stores a date as Date data type, there is no timezone attached.
 * When backend retrieves the date value, it converts to a javascript Date object.
 * Javascript Date object has a time component to it.
 * In this case, it will be DB date with the time <code>00:00:00</code> of the backend server timezone.
 * So if server timezone is +08:00 and DB date is <code>2025-06-01</code>, it will be <code>2025-06-01T00:00:00+08:00</code>
 * When backend sends the javascript date, it serialises the date to ISO string as <code>2025-05-31T16:00:00:00Z</code>
 * This method ensures that the original date in the DB, <code>2025-06-01</code> is returned
 * The timezone of the backend API server needs to be configured in the environment variable <strong>REACT_APP_SERVER_TIMEZONE</strong>
 * If not configured, <strong>UTC</strong> is assumed
 * @param isoDate - ISO string or JS Date from backend
 * @param format - Optional format string (default: 'YYYY-MM-DD')
 * @returns Formatted date matching DB, or empty string if input is invalid
 */
export function formatDbDate(
  isoDate: string | Date | null | undefined,
  format: string = 'YYYY-MM-DD'
): string {
  if (!isoDate) return '';

  const m = moment.tz(isoDate, SERVER_TIMEZONE);
  if (!m.isValid()) {
    console.warn('Invalid date passed to formatDbDate:', isoDate);
    return '';
  }

  return m.format(format);
}